// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Col/Col.sass
// module id = 351
// module chunks = 0